export default __webpack_public_path__ + "static/media/logo.f3ddce1b.png";